import withConfigTransport from '../../services/config-transport/withConfigTransport'
import VaBacktop from './VaBacktop.vue'

export default withConfigTransport(VaBacktop)
